// extracted by mini-css-extract-plugin
export default {"searchContainer":"Search_searchContainer__eK99T"};